module.exports = __webpack_public_path__ + "static/media/icon-comment.ef91853d.svg";